export default __webpack_public_path__ + "static/media/vchart.1b89352d.png";